var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fen-ye"},[_c('div',{staticClass:"el_pagination",class:{ishide:(_vm.totalPages==1)||(_vm.totalPages==0)||(_vm.totalPages=='')}},[_c('el-pagination',{attrs:{"page-size":1,"layout":"prev, pager, next","total":_vm.totalPages,"background":""},on:{"current-change":_vm.page}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73dacdde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fenye.vue
// module id = null
// module chunks = 